import { zetApi } from '@zet/network'

import ENDPOINTS from '../../endpoints'

export async function getAutoComplete(
  searchValue: string,
  fieldId: number,
  hash: string,
  isLOS: boolean,
  ocFieldCode: string,
  isV2?: boolean,
  fieldDependency: string = '',
  leadId: string = ''
) {
  const response = await zetApi.request({
    url: ENDPOINTS.autoComplete.endpoint(isLOS, isV2),
    method: ENDPOINTS.autoComplete.method,
    params: {
      letter: searchValue,
      ocFieldId: fieldId,
      ocFieldCode,
      filterOne: fieldDependency,
      leadId,
    },
    headers: {
      hash: encodeURIComponent(hash),
    },
  })

  return { results: response?.data?.data?.results ?? [] }
}
